export const input = (theme) => ({
    sizes: {
        sm: {
            height: '28px',
            fontSize: theme.fontSizes?.sm,
            iconGutter: '20px',
        },
        md: {
            height: '32px',
            fontSize: theme.fontSizes?.md,
            iconGutter: '24px',
        },
        lg: {
            height: '40px',
            fontSize: theme.fontSizes?.lg,
            iconGutter: '28px',
        },
    },
    variants: {
        default: {
            backgroundColor: theme.colors?.surface.default,
            borderColor: theme.colors?.border.control,
            color: theme.colors?.text.basic.primary,
            fontFamily: theme.fonts?.main,
            '&::placeholder': {
                color: theme.colors?.text.basic.placeholder,
            },
            '&:hover': {
                borderColor: theme.colors?.border.alt,
                backgroundColor: theme.colors?.component.hover,
            },
            '&:focus': {
                outline: 'none',
                borderColor: theme.colors?.border.focus,
                boxShadow: `0 0 0 ${theme.borderWidths?.sm} ${theme.colors?.effects.focusRing}`,
            },
            '&:disabled': {
                backgroundColor: theme.colors?.component.disabled,
                borderColor: theme.colors?.border.disabled,
                color: theme.colors?.text.basic.disabled,
                cursor: 'not-allowed',
            },
            '&[data-error="true"]': {
                borderColor: theme.colors?.border.danger,
            },
            '&[data-error="true"]:hover': {
                borderColor: theme.colors?.border.danger,
                backgroundColor: theme.colors?.component.hover,
            },
            '&[data-error="true"]:focus': {
                borderColor: theme.colors?.border.danger,
                boxShadow: `0 0 0 ${theme.borderWidths?.sm} ${theme.colors?.effects.focusRingError}`,
                outline: 'none',
            },
            filled: {
                borderColor: theme.colors?.border.control,
            },
        },
        subtle: {
            backgroundColor: theme.colors?.surface.subtle,
            borderColor: theme.colors?.border.subtle,
            color: theme.colors?.text.basic.primary,
            fontFamily: theme.fonts?.main,
            '&::placeholder': {
                color: theme.colors?.text.basic.placeholder,
            },
            '&:hover': {
                borderColor: theme.colors?.border.alt,
                backgroundColor: theme.colors?.component.hover,
            },
            '&:focus': {
                outline: 'none',
                borderColor: theme.colors?.border.focus,
                boxShadow: `0 0 0 ${theme.borderWidths?.sm} ${theme.colors?.effects.focusRing}`,
            },
            '&:disabled': {
                backgroundColor: theme.colors?.component.disabled,
                borderColor: theme.colors?.border.disabled,
                color: theme.colors?.text.basic.disabled,
                cursor: 'not-allowed',
            },
            '&[data-error="true"]': {
                borderColor: theme.colors?.border.danger,
            },
            '&[data-error="true"]:hover': {
                borderColor: theme.colors?.border.danger,
                backgroundColor: theme.colors?.component.hover,
            },
            '&[data-error="true"]:focus': {
                borderColor: theme.colors?.border.danger,
                boxShadow: `0 0 0 ${theme.borderWidths?.sm} ${theme.colors?.effects.focusRingError}`,
                outline: 'none',
            },
            filled: {
                borderColor: theme.colors?.border.control,
            },
        },
        code: {
            backgroundColor: theme.colors?.component.alt.default,
            borderColor: theme.colors?.border.alt,
            color: theme.colors?.text.basic.primary,
            fontFamily: theme.fonts?.code,
            '&::placeholder': {
                color: theme.colors?.text.basic.placeholder,
            },
            '&:hover': {
                borderColor: theme.colors?.border.alt,
                backgroundColor: theme.colors?.component.alt.hover,
            },
            '&:focus': {
                outline: 'none',
                borderColor: theme.colors?.border.focus,
                boxShadow: `0 0 0 ${theme.borderWidths?.sm} ${theme.colors?.effects.focusRing}`,
            },
            '&:disabled': {
                backgroundColor: theme.colors?.component.disabled,
                borderColor: theme.colors?.border.disabled,
                color: theme.colors?.text.basic.disabled,
                cursor: 'not-allowed',
            },
            '&[data-error="true"]': {
                borderColor: theme.colors?.border.danger,
            },
            '&[data-error="true"]:hover': {
                borderColor: theme.colors?.border.danger,
                backgroundColor: theme.colors?.component.alt.hover,
            },
            '&[data-error="true"]:focus': {
                borderColor: theme.colors?.border.danger,
                boxShadow: `0 0 0 ${theme.borderWidths?.sm} ${theme.colors?.effects.focusRingError}`,
                outline: 'none',
            },
            filled: {
                borderColor: theme.colors?.border.control,
            },
        },
    },
});
//# sourceMappingURL=input.js.map